import { apiService } from "./api";

export const dashboardService = {
  // Get admin dashboard stats
  getAdminDashboard: async () => {
    try {
      return await apiService.get("/dashboard/admin");
    } catch (error) {
      console.error("Dashboard API error:", error);
      // Return fallback data if API fails
      return {
        status: false,
        message: "Failed to load dashboard data",
        data: getFallbackDashboardData(),
      };
    }
  },

  // Get user dashboard stats
  getUserDashboard: async () => {
    try {
      return await apiService.get("/dashboard/user");
    } catch (error) {
      console.error("User dashboard API error:", error);
      return {
        status: false,
        message: "Failed to load user dashboard",
        data: getFallbackUserData(),
      };
    }
  },

  // Get platform overview
  getPlatformOverview: async () => {
    try {
      return await apiService.get("/dashboard/platform-overview");
    } catch (error) {
      console.error("Platform overview API error:", error);
      return {
        status: false,
        message: "Failed to load platform overview",
        data: getFallbackOverview(),
      };
    }
  },

  // Get user dashboard stats
  getUserDashboardStats: async () => {
    try {
      return await apiService.get("/dashboard/user/stats");
    } catch (error) {
      console.error("User dashboard stats API error:", error);
      return {
        status: false,
        message: "Failed to load user dashboard stats",
        data: getFallbackUserStats(),
      };
    }
  },

  // Get detailed user testimonials
  getUserTestimonialsDetailed: async (params = {}) => {
    try {
      return await apiService.get("/dashboard/user/testimonials", { params });
    } catch (error) {
      console.error("User testimonials detailed API error:", error);
      return {
        status: false,
        message: "Failed to load user testimonials",
        data: { testimonials: [], stats: {}, pagination: {} },
      };
    }
  },

  // Get user testimonial analytics
  getUserTestimonialAnalytics: async () => {
    try {
      return await apiService.get("/dashboard/user/analytics");
    } catch (error) {
      console.error("User testimonial analytics API error:", error);
      return {
        status: false,
        message: "Failed to load user analytics",
        data: getFallbackAnalytics(),
      };
    }
  },
};

// Fallback data functions
const getFallbackUserStats = () => ({
  testimonials: { total: 0, approved: 0, pending: 0, rejected: 0 },
  totalViews: 0,
  avgRating: 0,
  approvalRate: 0,
  recentTestimonials: [],
  userInfo: {
    userId: null,
    totalTestimonials: 0,
    joinedDate: new Date().toISOString(),
  },
});

const getFallbackAnalytics = () => ({
  monthlySubmissions: [],
  categoryDistribution: [],
  ratingDistribution: [],
  mostViewed: [],
  summary: {
    totalMonths: 0,
    totalCategories: 0,
    averageRating: 0,
    totalViews: 0,
  },
});
const getFallbackDashboardData = () => ({
  users: { total: 0, active: 0, admin: 0 },
  testimonials: { total: 0, pending: 0, approved: 0, rejected: 0 },
  guestLinks: { total: 0, active: 0, used: 0 },
  guestSubmissions: { total: 0, pending: 0 },
  recentActivity: { testimonials: [], guestSubmissions: [] },
});

const getFallbackUserData = () => ({
  testimonials: { total: 0, pending: 0, approved: 0, rejected: 0 },
  recentActivity: [],
});

const getFallbackOverview = () => ({
  totalViews: 0,
  avgRating: 0,
  approvalRate: 0,
  recentRegistrations: 0,
  totalTestimonials: 0,
});

export default dashboardService;
